// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'

import Vant from 'vant'
import 'vant/lib/index.css'

import apis from './api/apis'

// import VueIframe from "vue-iframe";
// Vue.use(VueIframe);

// 在main.js引入
 
// import KFormDesign from 'k-form-design'
// import 'k-form-design/lib/k-form-design.css'
// Vue.use(KFormDesign)


Vue.use(Vant)

Vue.prototype.$apis = apis

Vue.config.productionTip = false

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('userToken')
  if (['/index', '/setting', '/reset', '/changePhone', '/userInfo'].includes(to.path)) {
    if (!token) {
      next('/login')
    } else if (token && !store.getters.userInfo.nickName) {
      store.dispatch('getUserInfo').then(res => {
        next()
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js